module.exports = __webpack_public_path__ + "src/assets/img/06.88bdea50.png";